import { Root } from "react-dom/client"
import { createContext, useCallback, useContext, useState } from "react"
import { ConceptSceneView } from "./Views/ConceptSceneView"
import { QuickStartSceneView } from "./Views/QuickStartSceneView"
import { QuickStartVoyageSceneView } from "./Views/QuickStartVoyageSceneView"

enum DemoScenes {
  concept = "concept",
  quickstart = "quickstart",
  quickstartVoyage = "quickstart-voyage",
}

interface IDemoAppState {
  language: string;
  scene: string;
}

export const AppContext = createContext<IDemoAppState | undefined>(undefined);
export const GetApp = () => useContext(AppContext)!;

interface DemoAppProps {
  language: string;
  initialScene?: string;
}

export function DemoApp({ language, initialScene }: DemoAppProps) {
  const [scene, setScene] = useState<string>(initialScene || DemoScenes.concept);

  const app: IDemoAppState = {
    language: language,
    scene: scene,
  };

  const close = useCallback(() => {
    setScene("");
  }, []);

  let sceneView = null;
  switch (scene) {
    case DemoScenes.concept:
      sceneView = <ConceptSceneView onClose={close} />;
      break;
    case DemoScenes.quickstart:
      sceneView = <QuickStartSceneView onClose={close} />;
      break;
    case DemoScenes.quickstartVoyage:
      sceneView = <QuickStartVoyageSceneView onClose={close} />;
      break;
    default:
      sceneView = <div>Scene not found: {scene}</div>;
      break;
  }

  return (
    <AppContext.Provider value={app}>
      <div className="DemoApp">
        {sceneView}
      </div>
    </AppContext.Provider>
  );
}

export function RenderApp(root: Root, language: string = "en", scene?: string) {
  root.render(<DemoApp language={language} initialScene={scene} />);
}
